import { Component, Input } from '@angular/core';
import { dropdownAnimation } from '@shared/animations/dropdownAnimation';

@Component({
  selector: 'accordion',
  templateUrl: './accordion.component.html',
  styleUrls: ['./accordion.component.scss'],
  animations: [dropdownAnimation()],
})
export class AccordionComponent {
  @Input() title: string;
  public isCollapse: boolean = false;


  protected showContent() {
    this.isCollapse = !this.isCollapse;
  }
}
